import type { ReactNode } from 'react';

type OptionWithValue = {
  value: string;
  label?: string | ReactNode | null;
};

export const getOptionLabel = (
  value: string | null | undefined,
  optionLists: ReadonlyArray<ReadonlyArray<OptionWithValue>>,
  placeholder = ''
): string => {
  if (!value) return placeholder;

  for (const options of optionLists) {
    const label = options.find(option => option.value === value)?.label;

    if (label != null && label !== '') return String(label);
  }

  return value;
};
